<template>
  <div class="container page" style="width: 100%;
    background: #fff;">
    <div class="header">
      <van-nav-bar :title="$t('foorter.top32')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#000" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="listItem" v-for="(v,key) in msg" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <div class="listContent html"><p>{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      msg:{},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getMsgList(){
      this.$http({
        method: 'get',
        url: 'sys_get_msg_list'
      }).then(res=>{
        console.log(res);
        this.msg = res.data
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getMsgList();
      }, 500);
    },
  },
  created() {
    this.getMsgList();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}.act{color: rgb(245, 61, 135);border-bottom: solid #f53d87 3px}
.container .content {
  height: calc(100% - 20px);
  overflow: auto;
  padding-bottom: 40px;
}.nav-bar{background: unset;color:#000}::v-deep  .van-nav-bar__title{color:#000}
.container .content .listItem{
  margin-bottom: 20px;
  padding: 20px 30px 0 30px;
  position: relative;
  color: #000;
  border-bottom: 1px solid #999;
  background-color: #fff;
}
.container .content .listItem .listTitle{
  font-size: 32px;color: #222;
}
.container .content .listItem .listContent{
  border-bottom: 2px solid #f2f2f5;
  text-indent: 2em;
  padding: 5px 0;
  color: #323233;
  font-size: 24px;
}
.container .content .listItem .listTime{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
}
.container .content .listItem .listTime .listTimeText {
  color: #656566;
  font-size: 30px;
}
</style>
